module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.success) ? _c('div', {
    staticClass: "short-page"
  }, [_c('ui-alert', {
    attrs: {
      "dismissible": false
    }
  }, [_vm._v("Zostałeś wylogowany! Miłego dnia")]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Wylogowano poprawnie")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("Zaloguj sie ponownie")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c9a6a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Logout.vue
// module id = 255
// module chunks = 0